import MuiRadio from '@material-ui/core/Radio';
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit * 3,
  },
  checked: {
    '&$disabled': {
      color: 'inherit',
    },
  },
  colorPrimary: {
    '&$disabled': {
      color: theme.palette.primary.main,
    },
  },
  colorSecondary: {
    '&$disabled': {
      color: theme.palette.secondary.main,
    },
  },
  correct: {
    '&$disabled': {
      color: 'inherit',
    },
  },
  disabled: {},
});

const TriviaRadio = ({ isCorrect, classes: { correct, ...classes }, ...props }) => {
  let color = 'default';
  if (typeof isCorrect === 'boolean' && !isCorrect) {
    color = 'secondary';
  }
  return (
    <MuiRadio
      className={classNames({ [correct]: isCorrect })}
      classes={classes}
      color={color}
      {...props}
    />
  );
};

export const Radio = withStyles(styles)(TriviaRadio);
